<!--
================================================
Barre de navigation de l'application
================================================

-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>

  <div class="columns appNavbar " id="appNavbar" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
    <div class="column">
      <div class="columns is-mobile">
        <div class="column columnLogo
      is-one-fifth-fullhd
      is-one-fifth-widescreen
      is-one-fifth-desktop
      is-one-fifth-tablet
      is-10-mobile

">
          <router-link v-bind:to="{ name: 'timeTracking', params: {locale: $route.params.locale}}" class="logo">
            <img v-if="themeToDisplay=='dark'" src="../assets/img/AppLogoDarkModeBiColor.png" alt="Cronocloud App" width="164"
                 height="29">
            <img v-else src="../assets/img/AppLogo.png" alt="Cronocloud App" width="164" height="29">
          </router-link>
        </div>

        <div class="column  columnBurger is-1-touch is-hidden-tablet">
          <a v-on:click="toggleAppMenu" role="button" class="icon" aria-label="menu" aria-expanded="false">

            <!--<font-awesome-icon :icon="['fas', 'bars']" class="opener" v-show="$store.state.AppNavbar.menu.isOpened"/>-->
            <font-awesome-icon :icon="['fas', 'bars']" class="opener" id="appmenuOpener"
                               v-show="!AppMenuCompIsOpened"/>
            <font-awesome-icon :icon="['fas', 'times']" class="closer" id="appmenuCloser"
                               v-show="AppMenuCompIsOpened"/>
          </a>
        </div>

        <div class="column columnRight is-hidden-mobile">
          <div class="columns">

            <div class=" column organisation
                                  is-one-third-fullhd
                                  is-one-third-widescreen
                                  is-one-third-desktop
                                  is-one-third-tablet
                        ">
              <font-awesome-icon :icon="['far', 'building']" class="icon"/>
              <span class="orgName" v-if="organization!=null" id="AppNavbarOrganizationName">{{ organization.name }}</span>
            </div>

            <div class="column">
              <!--//sert d'espace uniquement-->
            </div>

            <div class="column columnFullname">


              <span class="updatesLink mr-5 is-hidden-touch is-hidden-desktop"> <a target="_blank" v-bind:href="'https://cronocloud.com/'+$i18n.locale+'/updates'">
                <font-awesome-icon :icon="['fas', 'gift']" class="icon"/>
                {{ $t('misesAjour') }}  </a>
              </span>

<!--              <premium-upgrade-c2a-btn-comp></premium-upgrade-c2a-btn-comp> @todo réactiver pour https://gitlab.com/ousmane1/kronocloud/-/issues/787-->

              <span class="fullname">
                                <span class="firstname" id="AppNavbarUserFirstname">{{ firstname }}</span>
                                <span class="name" id="AppNavbarUserName">{{ name }}</span>
                            </span>
            </div>

            <div class="trigramCont">
              <trigram-comp :firstname="firstname" :last-name="name"></trigram-comp>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>

import {mapState} from 'vuex'
import ThemeManagerComp from "@/components/ThemeManagerComp";
import TrigramComp from "@/components/TrigramComp";
import i18nMixin from "@/mixins/i18nMixin";
import PremiumUpgradeC2aBtnComp from "@/components/PremiumUpgradeC2aBtnComp";

export default {
  name: "AppNavbarComp",
  components: {PremiumUpgradeC2aBtnComp, TrigramComp, ThemeManagerComp},
  mixins:[i18nMixin],
  data: function () {
    return {
      locale: this.$route.params.locale
    }
  },


  computed: {
    ...mapState({ // pour mapper les prop du store
      AppMenuCompIsOpened: state => state.AppNavbarComp.menu.isOpened,
      organization: state => state.organization,
      firstname: state => state.user.firstname,
      name: state => state.user.name,
      themeToDisplay: state => state.app.themeToDisplay
    }),

    // other computed props :


  },

  watch: {
    // en cas de changement de viewport relance initAppMenuVisibility()
    $mq: 'initAppMenuVisibility'

  },

  methods: {

    /*
        Gère l'affichage du menu de l'app.
        Toggle #appMenu au clic sur #appmenuOpener/Closer
     */
    toggleAppMenu: function () {

      if (this.$store.state.AppNavbarComp.menu.isOpened === true) {
        this.$store.commit('UpdateAppNavBarCompIsOpened', false);
      } else if (this.$store.state.AppNavbarComp.menu.isOpened === false) {
        this.$store.commit('UpdateAppNavBarCompIsOpened', true);
      }
    },

    /*
        Initialise le visibilité de #appMenu
        (Masqué par défaut sur mobile, visible à partir de tablet)
     */
    initAppMenuVisibility: function () {
      if (this.$mq === 'mobile') {
        this.$store.commit('UpdateAppNavBarCompIsOpened', false);
      } else {
        this.$store.commit('UpdateAppNavBarCompIsOpened', true);
      }

    }

  },
  mounted: function () {
    this.initAppMenuVisibility();
  }

}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style scoped lang="scss">

@import "../assets/css/globalVar.scss";
@import "../assets/css/bulmaResponsiveDep.scss";


////////////////////////////////////////
// PRINT ----------------------------
////////////////////////////////////////
@media print {
  //* { color: red !important;}
  // masquage pour inpression
  //.AppMenu, #appMenu{display: none;}
  #appNavbar{display: none}
}

////////////////////////////////////////
// LIGHT UI ----------------------------
////////////////////////////////////////
.appNavbar {
  $navbarHeight: $appNavbarHeight;
  background: #fff;
  height: $navbarHeight;

  @include touch {
    background: #f9f9f9;
  }
  box-shadow: 0 0 4px #ccc;

  $mobileLogoBgColor: white;

  .columnLogo {
    height: $navbarHeight;
    background: #eff1f2;
    /*background-image: linear-gradient(to right top, #acd63d, #a2d138, #99cc33, #8fc72e, #85c229);*/

    @include touch {
      background: $mobileLogoBgColor;
    }
    .logo {
      display: block;
      width: 138px;
      height: 23px;
      margin: 1.1rem auto 0;
      cursor: pointer;
      position: relative;

      &:after{
        content: "Beta";
        font-size: .6rem;
        font-weight: bold;
        position: absolute;
        top:-.2rem;
        right: -2.3rem;
        color:#ccc;
        padding: .1rem .4rem;
      }
      @include touch {
        margin: 1.1rem auto 0 1.2rem;
      }
    }
  }

  .columnBurger {
    background: #eff1f2;
    @include  touch{
      background: $mobileLogoBgColor;
    }

    line-height: 4rem;
    height: $navbarHeight;
    width: $navbarHeight;

    a.icon {
      color: $brandThird;
      font-size: 1.2rem;
      margin-right: 1rem;

      &:active {
        color: $brandPrimary;
      }

      .opener {

      }

      .closer {
        display: block;
        font-size: 1.4rem;

      }
    }
  }

  .columnRight {
    .column {
      height: $navbarHeight;
      font-size: 0.9rem;
      color: #677c85;
    }

    .organisation {
      text-align: left;
      font-weight: 700;
      line-height: 4rem;
      padding-left: 1rem;

      .fa-building {
        color: #cdd3d6;
        margin: 0 0.5rem 0;
        font-size: 1.2rem;
      }

      .orgName {
        text-transform: uppercase;
        font-size: 0.9rem;
      }
    }


    .columnFullname {
      line-height: 4rem;
      text-align: right;
      /*padding-right: 2rem;*/

      .updatesLink{
        font-size: .85rem;

        a{
          color: $brandFourth;
          &:hover{
            .icon{
              color: $brandPrimary;
              transition: color 250ms ease-out;
            }
          }
          transition: color 300ms ease-in;
        }
        .icon{
          vertical-align: text-bottom;
          display: inline-block;
          margin: 0 .2rem -.2rem}
      }

      .userPic {
        border-radius: 32px;
        vertical-align: middle;
      }

      .fa-user-circle {
        font-size: 32px;
        color: #cdd3d6;
        vertical-align: middle;
        margin-right: 0.3rem;
      }

      .fullname {
        margin-left: 2rem;
        color: $brandThird;
        font-weight: 400;
        margin-right: 0.4rem;

        .firstname {
          margin-right: 0.4rem;
          text-transform: capitalize;

        }

        .name {
          font-weight: 800;
          text-transform: capitalize;

        }
      }

    }

    .trigramCont {
      margin: 1.3rem 2rem 0 0;
    }


  }

  //////////////////////////////////////
  // DARK UI ///////////////////////////
  &.darkMode {

    background: $darkDarkBlue;

    .columnLogo {
      background: $brandPrimary;
      .logo{
          &:after{
          color: darken($brandPrimary,12%);
        }
      }
    }
    .columnBurger {
      background: $brandPrimary;
    }
    a.icon {
      color: white;
    }

    .organisation{
      .icon{color: #bedef9 !important;}
      .orgName {
        color: #fff;
      }
    }

    .fullname {
      color: white !important;
    }

    .updatesLink {
      a {
        color: $darkLightBlue !important;
        &:hover{
          .icon{
            color: $darkContrastTxt !important;
            transition: color 250ms ease-out;
          }
        }
      }

      .icon {

      }
    }
  }

}


</style>
